import 'styles/modal'
import {div} from 'teact'

export Modal({ open, children }: { open: boolean }) ->
  if open: div('#Modal.overlay', children)



// WEBPACK FOOTER //
// ./src/components/modal.lsc